
import {Button} from "button";
import Stream from "frp/stream";
import { fieldName, Image, positioner } from "utils"
import SETTINGS from "settings"
import { TYPE, canGo } from 'network/network_api'
import { literal_price, progressive_jackpot_panel, reactive_button, reactive_label } from 'ui_commons'
import { KEYS } from 'src/lobby_ui'
import { RISK_CHOICE } from 'network/server_tool'

export function to_literal_text( value, balance ) {
    if (balance) {
        return value.toString() + balance.currency.delimiter + '0'.repeat(balance.currency.minor_unit)
    }
    return value.toString();
}

export default function( { uiConfig, helpConfig, parent, always_interactive_container, spec } )
{
    const space = parent.child( "ui" );

    const $barrelClick = space.s( "barrelClick" ).map( () => ({ consumed : false }) );

    const $isRoulette = space.s( "isRoulette" );
    const $notRoulette = $isRoulette.map( r => ! r );

    const $notRisk = space.s( "isRisk" ).map( i => ! i );
    const $notFreegames = space.s( "isFreegames" ).map( f => ! f );
    const $isHelp = space.s( "isHelp" );
    const $notHelp = $isHelp.map( h => ! h );
    const $notJackpot = space.s( "isJackpot" ).map( j => ! j );
    const $notBonus = space.s( "isBonus" ).map( b => ! b );
    const $not_error = parent.s( "isError" ).map( ie => ! ie )

    const panel_looks_like_enabled = space.s( 'panel_always_enabled', true )

    const $gambleVisible = Stream.any(
        space.s( "riskInvitation" ),
        $notHelp,
        $notBonus
    )
    .map( merge => _.every( merge ) && spec.risks.length > 0 )

    const $canSpin = space.s( "enabled" )
        .combineLatest( space.s( "canBet" ), space.s( "canPay" ), $notFreegames )
        .map( merge => _.every( merge ) );

    const container = new PIXI.Container;
    $isRoulette.subscribe( isRoulette => container.visible = ! isRoulette );

    if (!!uiConfig.main_panel) {
        const main_panel = Image( uiConfig.main_panel.frame );
        main_panel.position.set(uiConfig.main_panel.position.x, uiConfig.main_panel.position.y);
        container.addChild(main_panel);

        $notHelp
            .any($notRisk, $notJackpot, $notBonus, (nh, nr, nj, nb) => nh && nr && nj && nb)
            .name( space, 'main_panel_visibility' )
            .on( v => main_panel.visible = v )
    }

    const needProgJP = !!uiConfig.progressive_jackpot_panel;

    if (needProgJP) {
        progressive_jackpot_panel(
            parent,
            container,
            uiConfig.progressive_jackpot_panel,
            Stream.any( $notHelp, $notJackpot, $notFreegames, $notRisk, $notBonus )
                .map( merge => _.every( merge ) )
        )
    }



    /* _    ____ ___  ____ _    ____
       |    |__| |__] |___ |    [__
       |___ |  | |__] |___ |___ ___]
    */

    const { frames } = uiConfig;
    const createdLabels = []
    function l( desc, to, v, $text_v )
    {
        reactive_label(
            space,
            frames,
            desc,
            uiConfig.common ? uiConfig.common.font : undefined,
            to,
            v,
            $text_v,
            container,
        )
        createdLabels.push( desc )
    }


    space.s( 'multiplierValue' )
        .with( parent.s( 'balance' ), ( mult, balance ) => to_literal_text( mult, balance ) )
        .name( space, 'literal_mult' )
    space.s( 'win' )
        .with( parent.s( 'balance' ), ( win, balance ) => to_literal_text( win, balance ) )
        .name( space, 'literal_win' )
    space.s( 'price' )
        .with( parent.s( 'balance' ), ( price, balance ) => to_literal_text( price, balance ) )
        .name( space, 'literal_total_bet' )

    parent.s('risk:result')
        .with( parent.s( 'balance' ), ( {state, result}, balance ) => to_literal_text( result.currentWin, balance ) )
        .to(space.s('risk_win'));
    parent.s('risk:startRound')
        .any(parent.s('risk:leave'), () => '')
        .to(space.s('risk_win'));

    parent.s('risk:startRound')
        .with( parent.s( 'balance' ), ( round, balance ) => to_literal_text( round.currentWin, balance ) )
        .to(space.s('risk_step'));
    parent.s('risk:result')
        .with( parent.s( 'balance' ), ( {state, result}, balance ) => {
            let s = state.state;
            let step_size = (result.currentWin) ? result.currentWin / 2 : (s.previous_state && s.previous_state.open_win) ? s.previous_state.open_win : 0;
            return to_literal_text( step_size, balance )
        } )
        .to(space.s('risk_step'));

    const $isFreeGames = space.s('isFreeGames');
    parent.s('state')
        .map(state => !!(state.type && state.type == TYPE.FREEGAME))
        .to($isFreeGames);

    const $freeStepWin = space.s('free_win_step', 0);
    const $literalFreeStepWin = $freeStepWin.with( parent.s( 'balance' ), ( win, balance ) => to_literal_text( win, balance ) );

    parent.s( 'barrel:stop' )
        .with(parent.s('state'), (_, state) => state)
        .filter(state => state.type && state.type == TYPE.FREEGAME)
        .map(state => state.state.stage.win * state.state.multiplier)
        .to($freeStepWin);

    let flowFreeStepWin = null;
    parent.s('balance:winFlowUp')
        .with($freeStepWin, (_, win) => win)
        .on(win => {
            if (flowFreeStepWin) {
                flowFreeStepWin.stop();
            }

            if (win > 0) {
                let winObj = {value: win};
                const time = 1000 * Math.log(win);

                flowFreeStepWin = new TWEEN.Tween(winObj)
                    .to({value: 0}, time)
                    .onUpdate(() => {$freeStepWin.next(winObj.value | 0)})
                    .onStop(() => {$freeStepWin.next(0)})
                    .start();
            }
        });
    space.s( "request" )
        .with(space.s('state'), (request, state) => ({request, state}))
        .filter(({request, state}) => (canGo( TYPE.FREEGAME, state.state ) && request.type == REQUEST_TYPE.PROCEED))
        .on(() => {
            if (flowFreeStepWin) {
                flowFreeStepWin.stop();
            }
        });

    l( 'lines',     space.s( "linesValue" ),   [ $notHelp, $notJackpot, $notBonus ] );
    l( 'line_bet',  space.s( 'literal_mult' ), [ $notHelp, $notJackpot, $notBonus ] );
    l( 'win',       space.s( 'literal_win' ),  [ $notRisk, $notHelp, $notJackpot, $notBonus, $isFreeGames.map(is => !is) ], space.s( "win" ).with( $not_error, ( w, ne ) => w > 0 && ne ) );
    l( 'total_bet', space.s( 'literal_total_bet' ), [ $notRisk, $notHelp, $notJackpot, $notBonus ] )

    l( 'free_win',       space.s( 'literal_win' ),  $isFreeGames , space.s( "win" ).with( $not_error, ( w, ne ) => w > 0 && ne ) );
    l( 'free_step_win',  $literalFreeStepWin,  $isFreeGames ,  $freeStepWin.map(win => win > 0));

    l( 'risk_win',  space.s('risk_win'),  space.s( "isRisk" ), space.s( "risk_win" ).with( $not_error, ( w, ne ) => w > 0 && ne ) );
    l( 'risk_step',  space.s('risk_step'),  space.s( "isRisk" ) );

    //creating any other labels present in configuration:
    for ( const desc in frames )
    {
        if ( createdLabels.indexOf( desc ) >= 0 ) continue
        const spec = frames[ desc ]
        l(
            desc,
            spec.$value ? parent.s( spec.$value ) : undefined,
            spec.$visible ? parent.s( spec.$visible ) : undefined,
        )
    }

    /* ___  _  _ ___ ___ ____ _  _ ____
       |__] |  |  |   |  |  | |\ | [__
       |__] |__|  |   |  |__| | \| ___]
    */


    const { buttons } = uiConfig;
    const createdButtons = []
    function b(
        desc,
        to,
        keys,
        { e, v, equiv, look_like_enabled } = {},
        overriddenContainer,
    )
    {
        createdButtons.push( desc )
        const r = reactive_button(
            space,
            buttons,
            desc,
            to,
            keys,
            { e, v, equiv, look_like_enabled, on_button_fail : ()=>console.log( 'No texture for', desc, 'button' ) },
            overriddenContainer || container,
        )
        if ( desc != 'autoplay' && desc != 'stop' && desc != 'collect' ) space.s( 'buttons_' + desc + '_click' ).to( space.s( 'autoplayOff' ) )
        return r
    }

    b( "spin",             space.s( "spin" ),               [ KEYS.START ], {
        e : $canSpin,
        v : [
            space.s( "spinVisible" ),
            $notRisk,
            $notHelp,
            $notBonus
        ],
        equiv : $barrelClick,
        look_like_enabled : panel_looks_like_enabled
    } );
    b( "collect",          space.s( "collect" ),            [ KEYS.START ], {
        e : space.s( "collectEnabled" ),
        v : [
            space.s( "collectVisible" ),
            space.s( "finishVisible" ).map( f => ! f ),
            $notHelp,
        ],
        equiv : $barrelClick,
        look_like_enabled : panel_looks_like_enabled
    } );
    b( "stop",             space.s( "stop" ),               [ KEYS.START ], {
        e : space.s( "canInterruptBarrel" ),
        v : [
            space.s( "mayStop" ),
            $notHelp,
            $notBonus
        ],
        equiv : $barrelClick
    } );
    b( "start",            space.s( "start" ),              [ KEYS.AUTO ], {
        e : [
            space.s( "displayingWin" ).map( d => ! d ),
            space.s( "beginningFeature" ).map( b => ! b )
        ],
        v : [
            space.s( "canStartFeature" ),
            $notHelp,
            $notBonus
        ],
        equiv : $barrelClick
    } );
    b( "finish",           space.s( "finish" ),             [ KEYS.AUTO ], {
        e : [
            space.s( "enabled" ),
            space.s( "finishEnabled" ),
        ],
        v : [
            space.s( "finishVisible" ),
            $notHelp,
        ],
        equiv : $barrelClick
    } );
    b( "info",             space.s( "info" ),               [ KEYS.HELP ],        {
        e : space.s( "canBet" )
            .any(space.s( "collectEnabled" ), (canBet, collect) => canBet || collect),
        v : [
            //$notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled
    } );

    const $muteSound = parent.s("muteSound").desc( 'mute sound by player' );

    b( "sound_on",             space.s( "sound_on" ),               [ ],        {
        e : $muteSound,
        v : [
               $muteSound,
               $notHelp
            ]
    } );
    b( "sound_off",             space.s( "sound_off" ),               [ ],        {
        e : $muteSound.map(m => !m),
        v : [
            $muteSound.map(m => !m),
            $notHelp
        ]
    } );
    space.s("button_sound_on_click").map(() => false).to($muteSound);
    space.s("button_sound_off_click").map(() => true).to($muteSound);
    $muteSound
        .any( parent.s( 'tab_visibility' ), ( mute, tv ) => ({ mute, tv }) )
        .on( ({ mute, tv }) => {
            mute = mute || ( ! tv )
            Howler.mute( mute )
            if ( ! mute ) Howler.volume( SETTINGS.volume )
        } )

    b( "gamble",           space.s( "gamble" ),             [ KEYS.BET ],               {
        e : [
            space.s( "enabled" ),
            space.s( "finishVisible" ).map( v => ! v ),
            parent.s( 'state' ).map( s => s.state.risk_possible ),
        ],
        v : $gambleVisible
    } );
    b( "betmax",           space.s( "maxBet" ),             undefined,            {
        e : [
            space.s( "enabled" ),
            space.s( "canBet" ),
            space.s( "canMaxBet" ),
        ],
        v : [
            space.s( "canMaxBet" ).combineLatest( space.s( "canMinBet" ), ( max, min ) => max || ! min ),
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "betmin",           space.s( "minBet" ),             undefined,            {
        e : [
            space.s( "enabled" ),
            space.s( "canBet" ),
        ],
        v : [
            space.s( "canMinBet" ),
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "autoplay",         space.s( "autoplayOn" ),         [ KEYS.AUTO ],               {
        //не засеряем интерфейс на время кручения барабана:
        e : [
            $gambleVisible.map( gv => ! gv ),
            $notFreegames,
        ],
        v : [
            $gambleVisible.map( gv => ! gv ),
            $notRisk,
            $notHelp,
            $notBonus,
            $notJackpot,
            space.s( "isAutoplay" ).map( a => ! a ),
            space.s( "canStartFeature" ).map(feature => !feature)
        ]
    } );
    b( "autoplayoff",      space.s( "autoplayOff" ),        [ KEYS.AUTO ],              {
        //should always be able to cancel autoplay:
        //e : space.s( "enabled" ),
        v : [
            space.s( "isAutoplay" ),
            $gambleVisible.map( g => ! g ),
            $notHelp,
            $notJackpot,
            $notBonus,
            space.s( "canStartFeature" ).map(feature => !feature)
        ]
    } );
    b( "menu",             space.s( "goLobby" ),           [ KEYS.MENU ],              {
        //не засеряем интерфейс на время кручения барабана:
        /*e : space.s( "enabled" )
                .combineLatest(
                    space.s( "canBet" ),
                    parent.s( "isError" ),
                    ( e, c, i ) => ( e && c ) || i
                ),*/
        v : SETTINGS.nolobby ? false : $notHelp.any(
                $notRisk,
                $notJackpot,
                $notBonus,
                parent.s( "isError" ),
                $notRoulette,
                ( nr, nh, nj, nb, e, nrl ) => ( nr && nh && nj && nb && nrl ) || e
            )
    },
        always_interactive_container
    );
    b( "lines",            space.s( "increaseLines" ),      undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeLines" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeLines" ), (like, can) => like && can)
    } );
    b( "decrease_lines",   space.s( "decreaseLines" ),      undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeLines" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeLines" ), (like, can) => like && can)
    } );
    b( "increase_lines",   space.s( "increaseLines" ),      undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeLines" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeLines" ), (like, can) => like && can)
    } );
    b( "linebet",          space.s( "increaseMultiplier" ), [ KEYS.BET ],               {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeMultiplier" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeMultiplier" ), (like, can) => like && can)
    } );
    b( "decrease_linebet", space.s( "decreaseMultiplier" ), undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeMultiplier" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeMultiplier" ), (like, can) => like && can)
    } );
    b( "increase_linebet", space.s( "increaseMultiplier" ), undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeMultiplier" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeMultiplier" ), (like, can) => like && can)
    } );

    b( "visual_mode",             space.s( "visual_mode" ),               [ ],        {
        e : true,
        v : $notHelp,
    } );

    b( "end_pari",             space.s( "end_pari" ),               [ ],        {
        e : true,
        v : $notHelp,
    } );

    //inside help(info) scene:
    const n = b( "next",             space.s( "helpNext" ),           [ KEYS.KEY_9 ],               {
        e : space.s( "helpCanNext" ),
        v : $isHelp.map(h => h && (helpConfig.help.pages > 1)),
    } );
    positioner( space, n )
    b( "back",             space.s( "helpPrevious" ),       [ KEYS.KEY_1 ],               {
        e : space.s( "helpCanPrevious" ),
        v : $isHelp.map(h => h && (helpConfig.help.pages > 1)),
    } );
    b( "exit",             space.s( "helpExit" ),           [ KEYS.HELP ],               {
        e : true,
        v : $isHelp,
    } );

    //in risk choice button
    const $canRiskChoice = space.s('can_risk_choice');
    parent.s('risk:startComplete').map(() => true).to($canRiskChoice);
    parent.s('risk_result')
        .any(parent.s('risk:leave'), parent.s('risk:choiceIn'), () => false)
        .to($canRiskChoice);
    b( "risk_red",          space.s( "risk_red" ), [ KEYS.KEY_1 ],               {
        e : $canRiskChoice,
        v : space.s('isRisk').any( $notHelp, ( r, nh ) => r && nh ),
    } );
    b( "risk_black",          space.s( "risk_black" ), [ KEYS.KEY_9 ],               {
        e : $canRiskChoice,
        v : space.s('isRisk').any( $notHelp, ( r, nh ) => r && nh ),
    } );
    space.s( "risk_red" ).map(() => RISK_CHOICE.RED).to(parent.s('risk:choiceOut'));
    space.s( "risk_black" ).map(() => RISK_CHOICE.BLACK).to(parent.s('risk:choiceOut'));

    //creating any other buttons present in configuration:
    for ( const desc in buttons )
    {
        if ( createdButtons.indexOf( desc ) >= 0 ) continue
        b( desc )
    }

    const k = key => space.s( 'consumable_keyboard' ).filter( state => ! state.consumed && key.length ? _.includes( key, state.event ) : state.event == key );

    //set lines with keyboard:
    function setLines( key, lines )
    {
        k( key )
            .withLatestFrom(
                $notHelp,
                space.s( "canBet" ),
                parent.s( "isError" ),
                ( state, notHelp, canBet, isError ) => ({ state, can : notHelp && canBet && ! isError })
            )
            .filter( ({ can }) => can )
            .filter( ({ state }) => ! state.consumed )
            .do( ({ state }) => state.consumed = true )
            .map( () => lines )
            .subscribe( space.s( "setLines" ) );
    }
    switch ( spec.lines_array.length )
    {
        case 1:
            break
        case 5:
            setLines( KEYS.KEY_1, 0 );
            setLines( KEYS.KEY_3, 1 );
            setLines( KEYS.KEY_5, 2 );
            setLines( KEYS.KEY_7, 3 );
            setLines( KEYS.KEY_9, 4 );
            break
        default:
            console.error( "Undefined amount of lines groups." )
    }

    const $startImpulse = space.s( "startImpulse" );
    k( [ KEYS.START ] ).subscribe( $startImpulse );
    $startImpulse
        .withLatestFrom(
            parent.s( "isError" ),
            parent.s( "animating" ),
            ( key, isError, animating ) => ({ isError, animating })
        )
        .filter( ({ isError, animating }) => ! isError && ! animating )
        .map( () => undefined )
        .subscribe( space.s( "startKey" ) );

    if (needProgJP && !uiConfig.no_currency) {
        currency(
            container,
            space.s("credits"),
            parent.s("balance"),
            parent.s("balance:money"),
            $notHelp.any($notJackpot, $notBonus, (nh, nj, nb) => nh && nj && nb),
        )
    }


    return {
        space,
        ui : container,
    };
}

function currency( container, $credits, $balance, $money, $visible )
{
    const view = new PIXI.Container;
    container.addChild( view );
    $visible.subscribe( v => view.visible = v );

    // left billet
    const currencyFrame = Image( 'currency_frame.png' )
    currencyFrame.visible = false;
    view.addChild( currencyFrame );

    currencyFrame.position.set(
        SETTINGS.screen.resolution.height == 600 ? 76 : 98,
        SETTINGS.screen.resolution.height == 600 ? 518 : 665
    )

    const currencyValueLabel = new PIXI.Text(
        '',
        new PIXI.TextStyle(
        {
            fontFamily: 'Arial',
            fontSize: SETTINGS.screen.resolution.height == 600 ? 10 : 12,
            fill: ['#ffffff']
        } )
    );
    currencyValueLabel.position.set(
        SETTINGS.screen.resolution.height == 600 ? 11 : 12,
        SETTINGS.screen.resolution.height == 600 ? 9 : 11
    )
    currencyFrame.addChild( currencyValueLabel );


    // right billet
    const creditPriceFrame = Image( 'currency_frame.png' )
    creditPriceFrame.visible = false;
    view.addChild( creditPriceFrame );
    creditPriceFrame.position.set(
        SETTINGS.screen.resolution.height == 600 ? 606 : 778,
        SETTINGS.screen.resolution.height == 600 ? 518 : 665
    )

    const creditPriceLabel = new PIXI.Text(
        '',
        new PIXI.TextStyle(
        {
            fontFamily: 'Arial',
            fontSize: SETTINGS.screen.resolution.height == 600 ? 10 : 12,
            fill: ['#ffffff']
        } )
    );
    creditPriceLabel.position.set(
        SETTINGS.screen.resolution.height == 600 ? 10 : 12,
        SETTINGS.screen.resolution.height == 600 ? 9 : 11
    )
    creditPriceFrame.addChild( creditPriceLabel );

    $balance
        .any( $credits, $money, ( balance, credits, money ) => ({ balance, credits, money }) )
        .subscribe( ({ balance, credits, money }) =>
        {
            let visible = true;
            if ( ! balance.currency || ! balance.credit_price ) visible = false;
            else if ( balance.currency.visible === false || balance.currency.visible === "false" ) visible = false;
            currencyFrame.visible = creditPriceFrame.visible = visible
            if ( ! visible ) return;

            currencyValueLabel.text = balance.currency.code_name + " " + literal_price( money, balance.currency.minor_unit, balance.currency.delimiter );

            creditPriceLabel.text = "1 credit = " + literal_price( balance.credit_price, balance.currency.minor_unit, balance.currency.delimiter ) + " " + balance.currency.code_name;
        } );
}



// WEBPACK FOOTER //
// ./src/games/ui_view.es6